var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmilingFaceSuccessPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 33C25.6127 33 33 25.6127 33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33Z",
    fill: "url(#paint0_radial_3693_17338)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 33C25.6127 33 33 25.6127 33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33Z",
    fill: "url(#paint1_radial_3693_17338)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 33C25.6127 33 33 25.6127 33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33Z",
    fill: "url(#paint2_radial_3693_17338)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 33C25.6127 33 33 25.6127 33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33Z",
    fill: "url(#paint3_radial_3693_17338)",
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3693_17338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 33C25.6127 33 33 25.6127 33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3693_17338)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3693_17338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0949637 16.0293C-0.0770472 15.7949 0.000104055 15.7714 0.0226066 16.0094C0.0476073 16.2739 -0.000991724 16.8056 0.0107088 17.1264C0.0416895 17.9756 0.171871 18.714 0.306074 19.3146C0.738546 21.2502 1.33745 22.4974 1.89606 23.5541C3.73224 27.0276 5.74363 28.7865 7.70581 30.1121C10.582 32.0552 13.4816 32.6733 16.3836 32.8044C16.4568 32.8077 16.4689 33.2845 16.3969 33.3466C16.2671 33.4585 16.1062 33.3474 15.9734 33.3428C15.5916 33.3294 15.2099 33.3032 14.8282 33.2635C13.6964 33.1459 12.5647 32.9064 11.4353 32.5211C8.36441 31.4733 5.05333 29.6793 2.16167 24.6264C1.97976 24.3085 1.79929 23.9738 1.62138 23.6142C1.47909 23.3266 1.3382 23.0251 1.19978 22.7027C0.744503 21.6421 -0.316441 18.9272 -0.0949637 16.0293ZM16.3856 33.3517C16.3158 33.3538 16.2981 32.9094 16.3646 32.8171C16.4652 32.6776 16.616 32.7925 16.7221 32.7858C17.1626 32.7583 17.603 32.7175 18.0433 32.6622C19.2504 32.5106 20.4567 32.2518 21.6603 31.8532C24.6456 30.8646 27.8551 29.3574 30.6693 24.7269C30.8484 24.4322 31.026 24.1195 31.2012 23.7834C31.7335 22.7621 33.0677 20.051 32.9134 16.6807C32.9004 16.3966 32.9869 16.2265 33.0257 16.4702C33.0749 16.7805 33.0549 17.4275 33.0414 17.7717C32.9979 18.8742 32.8286 19.8066 32.65 20.5596C32.0843 22.9459 31.2899 24.3295 30.5625 25.4848C28.1982 29.2398 25.6302 30.7536 23.1336 31.8414C20.8943 32.8171 18.6381 33.2822 16.3856 33.3517Z",
    fill: "#401C02"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3693_17338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0949637 16.0293C-0.0770472 15.7949 0.000104055 15.7714 0.0226066 16.0094C0.0476073 16.2739 -0.000991724 16.8056 0.0107088 17.1264C0.0416895 17.9756 0.171871 18.714 0.306074 19.3146C0.738546 21.2502 1.33745 22.4974 1.89606 23.5541C3.73224 27.0276 5.74363 28.7865 7.70581 30.1121C10.582 32.0552 13.4816 32.6733 16.3836 32.8044C16.4568 32.8077 16.4689 33.2845 16.3969 33.3466C16.2671 33.4585 16.1062 33.3474 15.9734 33.3428C15.5916 33.3294 15.2099 33.3032 14.8282 33.2635C13.6964 33.1459 12.5647 32.9064 11.4353 32.5211C8.36441 31.4733 5.05333 29.6793 2.16167 24.6264C1.97976 24.3085 1.79929 23.9738 1.62138 23.6142C1.47909 23.3266 1.3382 23.0251 1.19978 22.7027C0.744503 21.6421 -0.316441 18.9272 -0.0949637 16.0293ZM16.3856 33.3517C16.3158 33.3538 16.2981 32.9094 16.3646 32.8171C16.4652 32.6776 16.616 32.7925 16.7221 32.7858C17.1626 32.7583 17.603 32.7175 18.0433 32.6622C19.2504 32.5106 20.4567 32.2518 21.6603 31.8532C24.6456 30.8646 27.8551 29.3574 30.6693 24.7269C30.8484 24.4322 31.026 24.1195 31.2012 23.7834C31.7335 22.7621 33.0677 20.051 32.9134 16.6807C32.9004 16.3966 32.9869 16.2265 33.0257 16.4702C33.0749 16.7805 33.0549 17.4275 33.0414 17.7717C32.9979 18.8742 32.8286 19.8066 32.65 20.5596C32.0843 22.9459 31.2899 24.3295 30.5625 25.4848C28.1982 29.2398 25.6302 30.7536 23.1336 31.8414C20.8943 32.8171 18.6381 33.2822 16.3856 33.3517Z",
    fill: "#401C02"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3427 21.4819C21.3691 21.461 21.4014 21.449 21.435 21.4477C21.4686 21.4464 21.5017 21.4557 21.5297 21.4745C21.5576 21.4932 21.5789 21.5203 21.5904 21.5519C21.6019 21.5834 21.6031 21.6179 21.5938 21.6502C21.0267 23.8134 18.9674 25.4129 16.5134 25.4129C14.0594 25.4129 11.9981 23.8093 11.4323 21.6454C11.4231 21.613 11.4244 21.5785 11.436 21.5469C11.4476 21.5153 11.4689 21.4882 11.4968 21.4694C11.5248 21.4507 11.558 21.4412 11.5916 21.4425C11.6253 21.4437 11.6576 21.4556 11.6841 21.4764C12.9046 22.4109 14.6177 22.9918 16.5134 22.9918C18.4092 22.9918 20.1222 22.4137 21.3427 21.4819Z",
    fill: "url(#paint4_radial_3693_17338)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3427 21.4819C21.3691 21.461 21.4014 21.449 21.435 21.4477C21.4686 21.4464 21.5017 21.4557 21.5297 21.4745C21.5576 21.4932 21.5789 21.5203 21.5904 21.5519C21.6019 21.5834 21.6031 21.6179 21.5938 21.6502C21.0267 23.8134 18.9674 25.4129 16.5134 25.4129C14.0594 25.4129 11.9981 23.8093 11.4323 21.6454C11.4231 21.613 11.4244 21.5785 11.436 21.5469C11.4476 21.5153 11.4689 21.4882 11.4968 21.4694C11.5248 21.4507 11.558 21.4412 11.5916 21.4425C11.6253 21.4437 11.6576 21.4556 11.6841 21.4764C12.9046 22.4109 14.6177 22.9918 16.5134 22.9918C18.4092 22.9918 20.1222 22.4137 21.3427 21.4819Z",
    stroke: "url(#paint5_linear_3693_17338)",
    strokeWidth: 0.173629,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2407 10.1812C12.0685 10.1812 12.8104 10.6586 13.3423 11.4165C13.8742 12.1748 14.2006 13.2189 14.2007 14.3687C14.2029 14.9733 14.1079 15.5741 13.9204 16.1489L13.9214 16.1499C13.8979 16.2281 13.8496 16.2966 13.7847 16.3462C13.7197 16.3957 13.6408 16.4243 13.5591 16.4263H13.5552C13.4623 16.4233 13.3731 16.3871 13.3042 16.3247C13.2359 16.2628 13.1918 16.1786 13.1792 16.0874L13.1333 15.8579C12.8703 14.7316 12.1103 13.9409 11.2378 13.9409C10.3071 13.9409 9.50443 14.8405 9.29639 16.0874C9.28378 16.1786 9.23966 16.2628 9.17139 16.3247C9.1025 16.3871 9.01326 16.4232 8.92041 16.4263H8.9165C8.83485 16.4243 8.75587 16.3957 8.69092 16.3462C8.62595 16.2966 8.57772 16.2281 8.5542 16.1499V16.1489C8.36758 15.5741 8.27419 14.973 8.27783 14.3687L8.28174 14.1548C8.31964 13.0898 8.6386 12.1275 9.13818 11.4165C9.6708 10.6587 10.4131 10.1813 11.2407 10.1812Z",
    stroke: "url(#paint6_linear_3693_17338)",
    strokeWidth: 0.138903
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8008 10.1812C22.6285 10.1812 23.3705 10.6586 23.9023 11.4165C24.4343 12.1748 24.7607 13.2189 24.7607 14.3687L24.7578 14.5952C24.7396 15.1238 24.6479 15.6481 24.4844 16.1519L24.4834 16.1509C24.4598 16.2285 24.4131 16.2969 24.3486 16.3462C24.2837 16.3957 24.2046 16.4242 24.123 16.4263H24.1191C24.0262 16.4233 23.9371 16.387 23.8682 16.3247C23.7998 16.2628 23.7548 16.1787 23.7422 16.0874L23.6973 15.8579C23.4342 14.7316 22.6727 13.9409 21.8008 13.9409C20.8716 13.9412 20.0681 14.8392 19.8594 16.0845C19.8472 16.1767 19.8033 16.2623 19.7344 16.3247C19.6654 16.3871 19.5764 16.4233 19.4834 16.4263H19.4795C19.3978 16.4243 19.3189 16.3957 19.2539 16.3462C19.1893 16.2969 19.1418 16.2286 19.1182 16.1509C18.93 15.5756 18.8354 14.9739 18.8379 14.3687C18.838 13.2188 19.1654 12.1747 19.6982 11.4165C20.2309 10.6587 20.9732 10.1813 21.8008 10.1812Z",
    stroke: "url(#paint7_linear_3693_17338)",
    strokeWidth: 0.138903
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1478 14.3123C14.1499 14.9104 14.0564 15.5049 13.8707 16.0733C13.8514 16.1375 13.8123 16.194 13.7589 16.2347C13.7056 16.2754 13.6408 16.2981 13.5738 16.2998C13.4972 16.2973 13.4241 16.2678 13.3673 16.2164C13.3105 16.1651 13.2739 16.0952 13.2639 16.0193C13.0531 14.7564 12.2335 13.815 11.2539 13.815C10.2742 13.815 9.45458 14.7564 9.24387 16.0193C9.23385 16.0952 9.19718 16.1651 9.14042 16.2164C9.08365 16.2678 9.01048 16.2973 8.93395 16.2998C8.86691 16.2981 8.8021 16.2754 8.74877 16.2347C8.69545 16.194 8.65634 16.1375 8.63704 16.0733C8.45217 15.5048 8.35978 14.9102 8.36338 14.3123C8.36338 12.0376 9.65914 10.1938 11.2573 10.1938C12.8554 10.1938 14.1478 12.0376 14.1478 14.3123Z",
    fill: "url(#paint8_radial_3693_17338)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7078 14.3123C24.711 14.9102 24.6187 15.5047 24.4341 16.0733C24.4148 16.1375 24.3757 16.194 24.3224 16.2347C24.269 16.2754 24.2042 16.2981 24.1372 16.2998C24.0607 16.2973 23.9875 16.2678 23.9307 16.2164C23.874 16.1651 23.8373 16.0952 23.8273 16.0193C23.6166 14.7564 22.7963 13.815 21.8173 13.815C20.8383 13.815 20.018 14.7564 19.8073 16.0193C19.7973 16.0952 19.7606 16.1651 19.7038 16.2164C19.6471 16.2678 19.5739 16.2973 19.4974 16.2998C19.4303 16.2981 19.3655 16.2754 19.3122 16.2347C19.2589 16.194 19.2198 16.1375 19.2005 16.0733C19.0144 15.5049 18.9209 14.9104 18.9234 14.3123C18.9234 12.0376 20.2191 10.1938 21.8173 10.1938C23.4154 10.1938 24.7078 12.0376 24.7078 14.3123Z",
    fill: "url(#paint9_radial_3693_17338)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3693_17338",
    x: -1.86129,
    y: 14.1055,
    width: 36.6547,
    height: 21.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.868143,
    result: "effect1_foregroundBlur_3693_17338"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3693_17338",
    x: -2.90306,
    y: 13.0637,
    width: 38.7382,
    height: 23.1108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38903,
    result: "effect1_foregroundBlur_3693_17338"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3693_17338",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4877) rotate(90) scale(32.9754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3693_17338",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4877 4.41268) rotate(90) scale(28.5627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782278
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3693_17338",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4877 4.41268) rotate(90) scale(28.5627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782278
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3693_17338",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4877 -3.59171) rotate(90) scale(36.5671 49.4517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922635,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.670207,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3693_17338",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5131 23.4196) scale(3.83969 4.01047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401C02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3693_17338",
    x1: 16.5131,
    y1: 25.5247,
    x2: 16.5131,
    y2: 21.3146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3693_17338",
    x1: 11.2394,
    y1: 16.5282,
    x2: 11.2394,
    y2: 10.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FED93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F9AF21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3693_17338",
    x1: 21.7995,
    y1: 16.5282,
    x2: 21.7995,
    y2: 10.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FED93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F9AF21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D14"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3693_17338",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.2515 13.2448) scale(3.68692 3.05825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401C02"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3693_17338",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8116 13.2448) scale(3.68692 3.05825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401C02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilingFaceSuccessPayment);
export default __webpack_public_path__ + "static/media/smiling_face_success_payment.df79157b516f9eda192ad27dfa58bfc5.svg";
export { ForwardRef as ReactComponent };